import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';

export enum ScoreboardViewType {
    Tournament,
    PairGame,
    SetGame,
    Empty,
}

@Injectable({ providedIn: 'root' })
export class ScoreboardResolveService {
    getComponent(event: EventModel): ScoreboardViewType {
        if (this.isEmptyScoreboard(event)) {
            return ScoreboardViewType.Empty;
        }

        if (!event.isTournamentGame()) {
            if (!event.scoreboard.started || !event.published) {
                return ScoreboardViewType.Empty;
            }
            if (event.isSetGame()) {
                return ScoreboardViewType.SetGame;
            }

            return ScoreboardViewType.PairGame;
        }

        return ScoreboardViewType.Tournament;
    }

    private isEmptyScoreboard(event: EventModel): boolean {
        if (event.scoreboard == null) {
            return true;
        }
        const keys = Object.keys(event.scoreboard);

        // Bwin.MobileSports.Host/Client/sports/src/event-model/mappers/scoreboard-factory.service.ts
        // createScoreboard
        return keys.length === 1 && keys[0] === 'type'; // scoreboard only with type.
    }
}
